var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWetlands = function SvgWetlands(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4BCEEB",
    d: "M32 64c17.673 0 32-14.327 32-32S49.673 0 32 0 0 14.327 0 32s14.327 32 32 32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    d: "M39.613 25.9a37.3 37.3 0 0 1-6.363-12.025 1.25 1.25 0 0 0-1.25-.9 1.25 1.25 0 0 0-1.25.9A37.3 37.3 0 0 1 24.338 25.9c-2.625 3.625-4.888 6.762-4.888 11.1a12.5 12.5 0 0 0 25 0c.05-4.275-2.212-7.475-4.837-11.1M32 47a10 10 0 0 1-10-10c0-3.525 1.95-6.25 4.413-9.638A44.5 44.5 0 0 0 32 18a44.5 44.5 0 0 0 5.588 9.362C40.088 30.775 42 33.475 42 37a10 10 0 0 1-10 10"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    d: "M31 41.9a5 5 0 0 1-4-4.913 1.25 1.25 0 0 0-2.5 0 7.5 7.5 0 0 0 6 7.363h.25a1.25 1.25 0 0 0 1.25-1 1.25 1.25 0 0 0-1-1.45"
  })));
};
export default SvgWetlands;